var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"body"},[_c('nuxt',{staticClass:"empty-page"}),_vm._v(" "),_c('component-alert'),_vm._v(" "),_c('component-toast'),_vm._v(" "),_c('component-image-browser')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }